module.exports = __webpack_public_path__ + "img/98b871e.png";